import { useState } from 'react';
import ReactDOM from 'react-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import palette from '../../styles/palette';
import { Stack } from '@mui/system';

const styles = {
  style: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '60%', md: '38%', lg: '28%', xl: '26%' },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    paddingBottom: 0,
  },
  errorTitle: {
    color: palette.gt_text_primary,
    fontSize: '1rem',
    fontWeight: 'bold',
    margin: '0.3rem 0',
  },
  errorDescription: {
    color: palette.gt_text_primary,
    margin: '0.5rem 0',
  },
  buttonStyle: {
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  tryAgainBtnStyle: {
    color: palette.gt_text_primary,
    fontSize: '1rem',
    fontWeight: 'bold',
    padding: '12px 16px',
    borderRadius: '0',
    backgroundColor: palette.gt_green_6,
    textTransform: 'none',
  },
};

export default function ApiErrorModal({ setIsError }) {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    setIsError(false);
  };

  return ReactDOM.createPortal(
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ bgcolor: 'rgba(47,67,81,0.8)' }}
      >
        <Box sx={styles.style}>
          <Stack direction="row" spacing={2}>
            <ErrorOutlineIcon sx={{ fontSize: '30px', color: 'orange' }} />
            <Stack direction="column">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={styles.errorTitle}
              >
                Oops we experienced an error.
              </Typography>
              <Typography
                className="modal-modal-description"
                sx={styles.errorDescription}
              >
                Please close this window and reserve your campaign again.
              </Typography>
            </Stack>
          </Stack>
          <Box sx={styles.buttonStyle}>
            <Button onClick={handleClose} style={styles.tryAgainBtnStyle}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>,
    document.querySelector('#root'),
  );
}
